import { STATSIG_EXPERIMENTS } from '@src/config/statsig-experiments.config'

export interface SlugExperimentTarget {
  slug: string
}
export interface ExperimentTargetsSchema<T> {
  targets: T[]
}

export const STATSIG_EXPERIMENT_TARGETS_CONFIG_KEYS: Partial<Record<STATSIG_EXPERIMENTS, string>> = {
  [STATSIG_EXPERIMENTS.PDP__PRODUCT_IMAGES_IMAGES_EXPERIMENTATION__ALL_US_CA]:
    'pdp__product-images_images-experimentation__all_us-ca__targets',
}

export const DEFAULT_EXPERIMENT_TARGETS: ExperimentTargetsSchema<SlugExperimentTarget> = { targets: [] }

/**
 * Returns true when any target entry's slug matches exactly.
 * No normalization — callers must supply the exact value that product.slug emits
 * (path only, no leading/trailing slash, no query string).
 */
export function matchSlugTargets(targets: SlugExperimentTarget[], slug: string | undefined): boolean {
  if (!slug) return false
  return targets.some(t => typeof t.slug === 'string' && t.slug.length > 0 && t.slug === slug)
}
